import type { FaireProductEntity } from "../../entity_types/product";

export const p_cum42uddjz: FaireProductEntity = {
  token: "p_cum42uddjz",
  type: "product",
  name: "Gemstone Angels | Amethyst | Pocket Angel | Crystal Angels",
  brandToken: "b_7ykttxenut",
  brandName: "Soothing Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/93b7a094982ac861655d725a84341d2eb6969f635d33dd3a8371c330083f1314.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/324258f9d124076939031a7e1fad310ec5361201e635b84844f78e7dc4bb74d2.png",
    "https://cdn.faire.com/fastly/4704ce829a5b7de0f7774721ecadfa1ecf98c1ca9747a2df27175f7ee9421794.png",
    "https://cdn.faire.com/fastly/de060792172471caec91ca92c95f890e10f6ab015516f5a21aad3e1cb23fa98a.jpeg",
    "https://cdn.faire.com/fastly/7b08df0d782306c1d3122246478bd1cd4ebbecbb3f0b2928870e595b05d4ed0a.png",
    "https://cdn.faire.com/fastly/33c6bf501beeedd655927add91147fec3a990c4d2926e5c223a4acc28d37f2c2.jpeg",
    "https://cdn.faire.com/fastly/05217622a179646114ab82a35e4e5a1a6bcab3f907b8d9be60f8fc46493d50fd.png",
    "https://cdn.faire.com/fastly/7ecbdb8e02694c0331e57a8c4a7fce19bf5b73cb10eb77b2bbd429c31e33a600.jpeg",
    "https://cdn.faire.com/fastly/a694cbe82c0fb1603663612f79a0baa38b46da201b20b3e5cde7ed40e8518d9f.png",
    "https://cdn.faire.com/fastly/3dae1aeb1de67cfac99d8bd1b94a7460f0148182ec15225bc340becedff940a1.jpeg",
    "https://cdn.faire.com/fastly/3d111105502be9e3a84b8a03458e21914e9577aa5eccbd6f2fad755615c0d7cf.png",
    "https://cdn.faire.com/fastly/ed8494b6d537cd9c46e78d42feefbbc17a6a541665f78774eb8d7fd2f46fe704.png",
    "https://cdn.faire.com/fastly/fe0a386f4c2960ac85c83d3cdf0565567f5f54e824a85cba24442c2af77b1cd2.png",
  ],
  priceDollars: 3.81,
  description:
    "💖A beautiful crystal angel hand-crafted from 100% natural, ethically sourced crystal.💖\n\nGemstone Angels are calming crystal figures used in wellness, spiritual rituals, and smudging to clear negative energy, balance emotions, and enhance inner peace\n\n📌Our angels are:\n✔ Crafted from high-quality crystal\n✔ Size : 2 inches\n\nSoothing Crystals has started a Journey in 2016, to offer high-quality, ethically-sourced crystals to collectors, artists, healers, and seekers from all walks of life.\n\nPeople consider it as: Gemstone angel figurines, pocket angel statue, healing crystal angel, guardian angel, angel aura gemstone.\n\nThis beautiful amethyst pocket angel stone is perfect for healing, featuring a mini amethyst angel figurine that’s delicately carved in a small, pocket-sized design, making it a thoughtful guardian angel crystal to carry with you",
  tags: [],
  msrpDollars: 7.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:40.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
